import Contact from "../Contact";

export const Terms = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '40px 20px'
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      backgroundColor: 'white',
      padding: '40px 20px',
      borderRadius: '12px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '10px'
    },
    lastUpdated: {
      fontSize: '0.95rem',
      color: '#7f8c8d',
      fontStyle: 'italic'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '40px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    },
    section: {
      marginBottom: '35px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '15px',
      paddingBottom: '10px',
      borderBottom: '2px solid #3498db'
    },
    paragraph: {
      color: '#555',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginBottom: '15px',
      textAlign: 'justify'
    },
    list: {
      color: '#555',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginLeft: '20px',
      marginBottom: '15px'
    },
    listItem: {
      marginBottom: '10px'
    },
    highlight: {
      backgroundColor: '#fff3cd',
      padding: '15px',
      borderLeft: '4px solid #ffc107',
      borderRadius: '4px',
      marginBottom: '20px'
    },
    highlightText: {
      color: '#856404',
      fontSize: '0.95rem',
      lineHeight: '1.6',
      margin: 0
    },
    subsection: {
      marginLeft: '20px',
      marginTop: '15px',
      marginBottom: '15px'
    },
    subsectionTitle: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#34495e',
      marginBottom: '10px'
    },
    contactBox: {
      backgroundColor: '#e8f4f8',
      padding: '20px',
      borderRadius: '8px',
      marginTop: '30px',
      textAlign: 'center'
    },
    contactText: {
      color: '#2c3e50',
      fontSize: '1rem',
      marginBottom: '10px'
    },
    contactEmail: {
      color: '#3498db',
      fontWeight: '600',
      fontSize: '1.1rem'
    }
  };

  return (
    <>
    <div style={styles.container}>
          <br />
    <br />
    <br />  <br />
    <br />
    <br />
      <div style={styles.header}>
        <h1 style={styles.title}>Terms and Conditions</h1>
      </div>

    <div style={styles.content}>
  <div style={styles.highlight}>
    <p style={styles.highlightText}>
      <strong>Important:</strong> Please read these terms and conditions carefully before using our service. 
      By accessing or using our service, you agree to be bound by these terms and conditions.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>1. Acceptance of Terms</h2>
    <p style={styles.paragraph}>
      By accessing and using this website and our services, you accept and agree to be bound by the terms 
      and provision of this agreement. If you do not agree to abide by the above, please do not use this 
      service. We reserve the right to modify these terms at any time, and such modifications shall be 
      effective immediately upon posting on this website.
    </p>
    <p style={styles.paragraph}>
      Your continued use of the service following the posting of changes will constitute your acceptance 
      of such changes. It is your responsibility to review these terms periodically for updates or changes.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>2. Use License</h2>
    <p style={styles.paragraph}>
      Permission is granted to temporarily access and use the materials on our website for personal, 
      non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, 
      and under this license you may not:
    </p>
    <ul style={styles.list}>
      <li style={styles.listItem}>Modify or copy the materials</li>
      <li style={styles.listItem}>Use the materials for any commercial purpose or for any public display</li>
      <li style={styles.listItem}>Attempt to reverse engineer any software contained on our website</li>
      <li style={styles.listItem}>Remove any copyright or other proprietary notations from the materials</li>
      <li style={styles.listItem}>Transfer the materials to another person or mirror the materials on any other server</li>
    </ul>
    <p style={styles.paragraph}>
      This license shall automatically terminate if you violate any of these restrictions and may be 
      terminated by us at any time. Upon termination, you must destroy any downloaded materials in your 
      possession whether in electronic or printed format.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>3. User Account and Registration</h2>
    <p style={styles.paragraph}>
      To access certain features of our service, you may be required to create an account. You agree to 
      provide accurate, current, and complete information during the registration process and to update 
      such information to keep it accurate, current, and complete.
    </p>
    
    <div style={styles.subsection}>
      <h3 style={styles.subsectionTitle}>Account Security</h3>
      <p style={styles.paragraph}>
        You are responsible for maintaining the confidentiality of your account password and for all 
        activities that occur under your account. You agree to immediately notify us of any unauthorized 
        use of your account or any other breach of security.
      </p>
    </div>

    <div style={styles.subsection}>
      <h3 style={styles.subsectionTitle}>Account Termination</h3>
      <p style={styles.paragraph}>
        We reserve the right to suspend or terminate your account at any time for any reason, including 
        but not limited to violation of these terms, fraudulent activity, or prolonged inactivity.
      </p>
    </div>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>4. Privacy and Data Protection</h2>
    <p style={styles.paragraph}>
      Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your 
      personal information. By using our service, you consent to our collection and use of personal data 
      as outlined in our Privacy Policy.
    </p>
    <p style={styles.paragraph}>
      We implement appropriate technical and organizational measures to protect your personal data against 
      unauthorized or unlawful processing, accidental loss, destruction, or damage. However, no method of 
      transmission over the Internet or electronic storage is 100% secure.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>5. Acceptable Use Policy</h2>
    <p style={styles.paragraph}>
      You agree not to use our service for any unlawful purpose or in any way that interrupts, damages, 
      or impairs the service. Prohibited activities include, but are not limited to:
    </p>
    <ul style={styles.list}>
      <li style={styles.listItem}>Violating any applicable local, state, national, or international law</li>
      <li style={styles.listItem}>Transmitting any harmful code, viruses, or malicious software</li>
      <li style={styles.listItem}>Engaging in any form of harassment, abuse, or hate speech</li>
      <li style={styles.listItem}>Infringing on intellectual property rights of others</li>
      <li style={styles.listItem}>Collecting or harvesting any personally identifiable information</li>
      <li style={styles.listItem}>Attempting to gain unauthorized access to our systems or networks</li>
    </ul>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>6. Intellectual Property Rights</h2>
    <p style={styles.paragraph}>
      All content included on this website, such as text, graphics, logos, images, audio clips, digital 
      downloads, data compilations, and software, is the property of Foxtroit Private Limited or its content 
      suppliers and is protected by international copyright laws.
    </p>
    <p style={styles.paragraph}>
      The compilation of all content on this site is our exclusive property. All trademarks, service marks, 
      and trade names are proprietary to Foxtroit Private Limited or other respective owners that have granted 
      us the right to use such marks.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>7. Payment and Billing</h2>
    <p style={styles.paragraph}>
      If you purchase any services or products through our website, you agree to pay all fees and charges 
      in accordance with the billing terms in effect at the time the fee or charge becomes payable.
    </p>
    
    <div style={styles.subsection}>
      <h3 style={styles.subsectionTitle}>Refund Policy</h3>
      <p style={styles.paragraph}>
        We offer a 30-day money-back guarantee for most of our services. Refund requests must be submitted 
        within 30 days of purchase. Certain services may be non-refundable as specified at the time of purchase.
      </p>
    </div>

    <div style={styles.subsection}>
      <h3 style={styles.subsectionTitle}>Subscription Services</h3>
      <p style={styles.paragraph}>
        For subscription-based services, your subscription will automatically renew at the end of each 
        billing period unless you cancel prior to the renewal date. You may cancel your subscription at 
        any time through your account settings.
      </p>
    </div>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>8. Disclaimer of Warranties</h2>
    <p style={styles.paragraph}>
      The materials on our website are provided on an 'as is' basis. Foxtroit Private Limited makes no 
      warranties, expressed or implied, and hereby disclaims and negates all other warranties including, 
      without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, 
      or non-infringement of intellectual property.
    </p>
    <p style={styles.paragraph}>
      We do not warrant that the service will be uninterrupted, timely, secure, or error-free, or that 
      defects will be corrected. We make no warranties about the accuracy or completeness of the content 
      or the content of any sites linked to our website.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>9. Limitation of Liability</h2>
    <p style={styles.paragraph}>
      In no event shall Foxtroit Private Limited or its suppliers be liable for any damages (including, without 
      limitation, damages for loss of data or profit, or due to business interruption) arising out of the use 
      or inability to use our service, even if Foxtroit or its authorized representative has been notified of 
      the possibility of such damage.
    </p>
    <p style={styles.paragraph}>
      Some jurisdictions do not allow limitations on implied warranties or limitations of liability for 
      consequential or incidental damages. In such jurisdictions, our liability shall be limited to the 
      maximum extent permitted by law.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>10. Indemnification</h2>
    <p style={styles.paragraph}>
      You agree to indemnify, defend, and hold harmless Foxtroit Private Limited, its officers, directors, 
      employees, agents, and third parties, for any losses, costs, liabilities, and expenses relating to or 
      arising out of your use of our service, your violation of these terms, or your violation of any rights 
      of a third party.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>11. Governing Law</h2>
    <p style={styles.paragraph}>
      These Terms and Conditions are governed by and construed in accordance with the laws of India, and 
      disputes shall be resolved under the jurisdiction of Bangalore courts.
    </p>
    <p style={styles.paragraph}>
      Any dispute arising out of or related to these terms shall be resolved through binding arbitration 
      in accordance with the applicable arbitration rules.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>12. Changes to Terms</h2>
    <p style={styles.paragraph}>
      We reserve the right to revise these terms and conditions at any time. By using this website and 
      our services, you are agreeing to be bound by the current version of these terms and conditions.
    </p>
    <p style={styles.paragraph}>
      Material changes to these terms will be notified to registered users via email or through a prominent 
      notice on our website at least 30 days before the changes take effect.
    </p>
  </div>

  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>13. Contact Information</h2>
    <p style={styles.paragraph}>
      If you have any questions about these Terms and Conditions, please contact us:
    </p>
    <div style={styles.contactBox}>
      <p style={styles.contactText}>Email us at:</p>
      <p style={styles.contactEmail}>legal@foxtroit.in</p>
      <p style={{...styles.contactText, marginTop: '15px'}}>
       Or write to us at:<br />
       MR building, 3rd floor<br />
       Hbr layout, Hennur Cross<br />
       Bangalore, Karnataka, 560043<br />
       Bangalore, India
      </p>
    </div>
  </div>
</div>

    </div>
    <Contact />
    </>
  );
};

export default Terms;